<template>
      <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
      >
        <form>
          <!-- <h4>Update Profile</h4> -->
          <md-card>
            <md-card-content class="card">
              <b>Profile</b>
              <div>
                <md-field>
                  <label for="fullName">Full Name</label>
                  <md-input
                    readonly
                    v-model="form.fullName"
                    placeholder="Enter Full Name"
                    id="fullName"
                  ></md-input>
                </md-field>
                <md-field>
                  <label for="email">Email</label>
                  <md-input
                    readonly
                    v-model="form.email"
                    placeholder="Enter Email"
                    id="email"
                  ></md-input>
                </md-field>
                <md-field>
                  <label>Phone Number</label>
                  <md-input
                    readonly
                    v-model="form.phoneNumber"
                    placeholder="Enter Phone Number"
                    id="phoneNumber"
                  ></md-input>
                </md-field>

                <!-- <md-button
                class="md-raised"
                data-background-color="orange"
                @click="updateProfile()"
                >Update Profile</md-button
              > -->
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
      <md-snackbar
        md-position="center"
        :md-duration="6000"
        :md-active.sync="snackBar.show"
        md-persistent
      >
        <span>{{ snackBar.message }}</span>
      </md-snackbar>
    </div>
</template>

<script>

export default {
  data() {
    return {
      form: {
        fullName: this.$store.state.userData.name || '',
        email: this.$store.state.userData.email || '',
        phoneNumber: this.$store.state.userData.phone || '',
      },
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    async updateProfile() {
      try {
        if (!this.form.fullName || !this.form.email || !this.form.phoneNumber) {
          this.snackBar = {
            show: true,
            message: 'Please enter all fields before proceeding',
          };
          return;
        }
        this.$store.commit('busyStatus', true);
        // const { message } = await http.authReq(
        //   "/dashboard/password/update",
        //   {
        //     ...this.form,
        //   },
        //   "post"
        // );

        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          // message,
          message: 'Success',
        };
      } catch (error) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
    },
  },
};
</script>

<style scoped>
.md-card-header {
  background: transparent !important;
  font-weight: 500;
}
.card {
  padding-top: 2em;
}
</style>
